import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import ContentCard from 'redesign/components/organisms/content-card'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import { TaskContainer } from './styles'
import type { TaskListProps } from './types'
import { normalizeTaskContents, normalizeTaskHeader } from './utils'

const TaskList: React.FC<TaskListProps> = ({
  tasks,
  isOffice,
  isLoading,
  onTaskClick,
  showLoadMoreButton,
  loadMore,
  hasFilters,
}) => {
  const { t, locale } = useFavurTranslation()

  return (
    <ListWrapper
      hasContent={Boolean(tasks.length)}
      isLoading={isLoading}
      showLoadMoreButton={showLoadMoreButton}
      loadMore={loadMore}
      noContentBlock={<EmptyPage variant={EMPTY_PAGE_VARIANTS.noPersonalTasks} />}
      hasFilters={hasFilters}
    >
      <TaskContainer>
        {tasks.map((task) => {
          const {
            bodyText: subtitle,
            startText,
            secondaryText,
            endText,
            icon,
          } = normalizeTaskContents({
            t,
            task,
            locale,
          })
          const title = normalizeTaskHeader({ task, isOffice, t })
          const status = task?.statusFe

          return (
            <ContentCard
              dataTestId={`task-list-content-card-${isOffice ? 'office' : 'frontliner'}-${task.statusFe}-${
                task.taskType
              }`}
              key={task.favurUuid}
              header={{
                icon: <FramedIcon icon={icon} isFilled />,
                title,
                subtitle,
                overflowSingleLine: true,
                subtitleOverflowSingleLine: true,
              }}
              statesProps={{
                startText,
                endText,
                secondaryText,
                endTextVariant: 'caption',
                status,
              }}
              onClick={() => onTaskClick({ task })}
              overflowBodyText
            />
          )
        })}
      </TaskContainer>
    </ListWrapper>
  )
}

export default TaskList
